import { isDefined } from "@clipboard-health/util-ts";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { type FieldErrors, type UseFormRegister } from "react-hook-form";

import { type CredentialsFormData } from "../api/schema";

interface AttendanceOnDemandTimeclockCredentialsProps {
  register: UseFormRegister<CredentialsFormData>;
  errors: FieldErrors<CredentialsFormData>;
  showPin?: boolean;
  onTogglePinVisibility: () => void;
  externalIdErrorPlaceholder?: string;
}

export function AttendanceOnDemandTimeclockCredentials({
  register,
  errors,
  showPin,
  onTogglePinVisibility,
  externalIdErrorPlaceholder,
}: AttendanceOnDemandTimeclockCredentialsProps) {
  return (
    <>
      <TextField
        fullWidth
        label="AoD Person Number"
        InputLabelProps={{
          shrink: isDefined(externalIdErrorPlaceholder) ? true : undefined,
        }}
        // FIXME: Automatically disabled during ESLint config update
        // eslint-disable-next-line no-implicit-coercion
        error={!!errors.externalId}
        sx={
          isDefined(externalIdErrorPlaceholder)
            ? {
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "#000000",
                },
              }
            : {}
        }
        helperText={errors.externalId?.message}
        disabled={isDefined(externalIdErrorPlaceholder)}
        placeholder={externalIdErrorPlaceholder}
        {...register("externalId")}
      />
      <TextField
        fullWidth
        label="Time Clock PIN"
        type={showPin ? "text" : "password"}
        // FIXME: Automatically disabled during ESLint config update
        // eslint-disable-next-line no-implicit-coercion
        error={!!errors.timeclockPin}
        helperText={errors.timeclockPin?.message}
        {...register("timeclockPin")}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                edge="end"
                onClick={onTogglePinVisibility}
              >
                {showPin ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <TextField
        fullWidth
        label="Time Clock Badge"
        // FIXME: Automatically disabled during ESLint config update
        // eslint-disable-next-line no-implicit-coercion
        error={!!errors.timeclockBadge}
        helperText={errors.timeclockBadge?.message}
        {...register("timeclockBadge")}
      />
    </>
  );
}
